<template>
    <app-dialog width="700px" :value="value" :title="$t('addressEdit.title')" v-bind="$attrs" @input="onDialogInput">
        <template v-slot:content>
            <v-form ref="form" lazy-validation>
                <div class="px-3">
                    <v-row class="my-0">
                        <v-col cols="12">
                            <v-text-field class="text-field-asterisk" v-model="editedAddress.name" :rules="[rules.required]">
                                <template v-slot:label>
                                    <span>{{ $t('userDetails.name') }}&nbsp;</span>
                                    <v-icon class="red--text" style="font-size: 0.75rem !important"> mdi-asterisk </v-icon>
                                </template>
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="my-0">
                        <v-col cols="12">
                            <v-text-field :label="$t('orders.affinity.deliveryAddress')" v-model="editedAddress.address"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="my-0">
                        <v-col cols="4">
                            <v-text-field :label="tb('Código Postal')" v-model="editedAddress.postal_code"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field :label="tb('Localidade')" v-model="editedAddress.location"></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field :label="tb('Telefone')" v-model="editedAddress.telephone_number"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="my-0">
                        <v-col cols="12">
                            <v-textarea class="myprovet-textarea" :label="$t('orders.affinity.observations')" v-model="editedAddress.observations"></v-textarea>
                        </v-col>
                    </v-row>
                </div>
            </v-form>
        </template>

        <template v-slot:buttons="{}">
            <v-btn text outlined class="myprovet-btn-cancel" @click="onCloseDialog"> {{ $t('common.cancel') }} </v-btn>

            <v-btn text class="myprovet-btn-ok" @click="sendEmail"> {{ $t('addressEdit.sendRequest') }} </v-btn>
        </template>
    </app-dialog>
</template>

<script>
import { i18n } from '@/i18n';
import { axios } from '@/Services/Backend';

export default {
    data() {
        return {
            editedAddress: {
                name: '',
                address: '',
                location: '',
                postal_code: '',
                observations: '',
                telephone_number: '',
            },
            rules: {
                required: (value) => (value && !!value) || i18n.t('validation.required'),
            },
        };
    },

    created() {
        this.copyOriginalData();
    },

    props: {
        value: { default: false },
        originalAddress: Object,
        branchId: String,
    },

    methods: {
        copyOriginalData() {
            this.editedAddress.name = this.originalAddress.name;
            this.editedAddress.telephone_number = this.originalAddress.telephone_number;
            this.editedAddress.address = this.originalAddress.address;
            this.editedAddress.postal_code = this.originalAddress.postal_code;
            this.editedAddress.location = this.originalAddress.location;
            this.editedAddress.observations = this.originalAddress.observations;
        },

        sendEmail() {
            if (!this.$refs.form.validate()) return;

            axios
                .post(`/api/branches/${this.branchId}/addresses/${this.originalAddress.id}/request-update`, { originalAddress: this.originalAddress, editedAddress: this.editedAddress })
                .then(() => {
                    this.showSuccess(this.$t('orders.changeRequest.sent'));
                    this.$emit('on-success', true);
                })
                .catch(() => {
                    this.showError(this.$t('orders.changeRequest.error'));
                    this.loading = false;
                });
        },

        onDialogInput(event) {
            if (!event) {
                this.$emit('on-cancel', false);
            }
        },

        onCloseDialog() {
            this.$emit('on-cancel', false);
        },
    },
};
</script>
